import { motion } from "framer-motion";
import { CalendarDays, Play, Sparkles } from "lucide-react";
import { ASSETS, EPISODES, getEpisodeEmbed, getFeaturedSpecial } from "@/data/magicalContent";
import { scrollToId } from "@/utils/scroll";

export function EpisodeTheatre({ selectedNumber, onSelectEpisode }) {
  const selected = EPISODES.find((episode) => episode.number === selectedNumber) || EPISODES[14];
  const latestPlayable = EPISODES[13];
  const featuredSpecial = getFeaturedSpecial();

  return (
    <section id="episodes" className="ns-section ns-episodes" data-testid="episodes-section">
      <motion.div className="ns-theatre-heading" initial={{ opacity: 0, y: 32 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
        <p className="ns-kicker">Chapter 02 · Watch the adventures</p>
        <h2>Every episode is<br /><em>a glowing doorway.</em></h2>
        <button className="ns-button ns-button-primary" data-testid="episode-play-button" onClick={() => onSelectEpisode(latestPlayable.number)}><Play size={15} fill="currentColor" /> Play Episode 14 now</button>
      </motion.div>
      <div className="ns-theatre-grid">
        <motion.div className="ns-video-frame" initial={{ opacity: 0, scale: 0.96 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.7 }}>
          {featuredSpecial && selected.comingSoon ? (
            <>
              <span className="ns-special-badge" data-testid="featured-special-badge"><Sparkles size={13} /> {featuredSpecial.label}</span>
              <iframe data-testid="featured-special-iframe" src={`https://www.youtube.com/embed/${featuredSpecial.youtubeId}?rel=0&modestbranding=1`} title={`Niyati & Shivu ${featuredSpecial.label}: ${featuredSpecial.title}`} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen />
            </>
          ) : selected.comingSoon ? (
            <div className="ns-finale-poster" data-testid="episode-coming-soon-panel">
              <img src={ASSETS.family} alt="Niyati and Shivu Season 1 Finale artwork" />
              <div><span><Sparkles size={15} /> Season 1 Finale</span><h3>Episode 15<br /><em>The Great Magical Call</em></h3><p><CalendarDays size={16} /> Coming soon</p><button className="ns-button ns-button-ghost" data-testid="finale-notify-button" onClick={() => scrollToId("newsletter")}>Get the magical reminder</button></div>
            </div>
          ) : (
            <iframe data-testid="episode-iframe" src={getEpisodeEmbed(selected)} title={`Niyati & Shivu Episode ${selected.number}: ${selected.title}`} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen />
          )}
        </motion.div>
        <div className="ns-episode-playlist" data-testid="episode-playlist">
          {EPISODES.map((episode) => (
            <button key={episode.number} className={`ns-episode-card ${selected.number === episode.number ? "is-active" : ""}`} data-testid={`episode-card-${episode.number}`} onClick={() => onSelectEpisode(episode.number)}>
              <span>{String(episode.number).padStart(2, "0")}</span><div><strong>{episode.title}</strong><small>{episode.comingSoon ? "Coming soon" : `${episode.duration} · ${episode.description}`}</small></div><Play size={14} fill={episode.comingSoon ? "none" : "currentColor"} />
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
